<template>
    <div class="msgList acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{$t('account.message')}}
        </div>
        <div class="msgbos">
            <div class="msglistitem flexbox fle-sb" v-for="(item,index) in list" :key="index">
                <div class="flex2 line24 texal" @click="readMsg(item.id, index)">
                    <el-badge v-if="item.status==0" is-dot class="bdgitem">
                        <i class="el-icon-message-solid ringico colorb"></i>
                    </el-badge>
                    <el-badge v-else class="bdgitem">
                        <i class="el-icon-message-solid ringico colorb"></i>
                    </el-badge>
                    {{item.content2}}
                </div>
                <div class="msgtimer">{{item.createdate}}</div>
            </div>
        </div>

    </div>
</template>

<script>
    // @ is an alias to /src
    import {
        myMsgList, readMyMsg
    } from '@/api/account.js'

    export default {
        name: 'msgList',
        data() {
            return {
                list: []
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        mounted() {
            myMsgList().then(res => {
                if (res.code == 1) {
                    this.list = res.data.list;
                }
            }).catch(_ => {

            });
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            readMsg(id, index) {
                readMyMsg(id).then(res => {
                    if (res.code == 1) {
                        this.list[index].status = 1;
                    }
                }).catch(_ => {

                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .msgList {
        font-size: 18px;

        .msglistitem {
            padding: 10px 20px;
            box-sizing: border-box;
            font-size: 20px;
            border-bottom: 0.1px dotted #d8d8d8;

            .ovrelps {
                overflow: hidden;
                padding: 10px 0px;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
      .line24{
        line-height: 24px;
      }

            .bdgitem {
                margin-right: 20px;

                .ringico {
                    font-size: 30px;
                }
            }
        }

    }
</style>
